<template>
  <app-layout>
    <template #header>
      <Breadcrumb :items="[
      {
          label : 'Home',
          link : '/',
      },
      {
          label : 'Entrevista',
          link : route('entrevista.index'),
      },
      {
          label : 'Nova entrevista',
          link :  route('entrevista.create'),
      }
      ]"></Breadcrumb>
    </template>
    <div class="max-w-screen-2xl mx-auto py-2 sm:px-2 lg:px-2">
      <div class="md:grid">
        <div class="mt-2 mt-sm-5 md:mt-0 md:col-span-2">
          <form @submit.prevent="save">
            <div class="shadow overflow-hidden sm:rounded-md">
              <div class="px-6 py-5 bg-white">
                <div class="grid grid-cols-12 gap-6 py-2">
                  <div class="col-span-12  ">
                    <label class="block font-medium text-gray-700 mb-2">
                      <span>
                        Buscar colaborador
                      </span>
                    </label>
                    <SelectAutocomplete
                      class="mt-1"
                      placeholder="Nome ou matricula ou cpf"
                      primary-key="id"
                      label="nome"
                      :multiple="false"
                      v-model="form.funcionario_id"
                      url-search="/api/select/funcionario-demitido"
                    ></SelectAutocomplete>
                    <jet-input-error
                      :message="form.errors.funcionario_id"
                      class="mt-2"
                    />
                  </div>
                  <div
                    v-if="temFuncionario"
                    class="col-span-12"
                  >
                    <label class="block font-medium text-gray-700 mb-2">
                      <span>
                        Superior imediato
                      </span>
                    </label>
                    <el-input v-model="form.superior_imediato"></el-input>
                    <jet-input-error
                      :message="form.errors.superior_imediato"
                      class="mt-2"
                    />
                  </div>
                  <div
                    v-if="temFuncionario"
                    class="col-span-12"
                  >
                    <label class="block font-medium text-gray-700 mb-2">
                      <span>
                        O Funcionário pediu demissão?
                      </span>
                    </label>
                    <el-radio-group v-model="form.demissao_solicitada_por">
                      <el-radio label="FUNCIONARIO">Sim</el-radio>
                      <el-radio label="EMPRESA">Não</el-radio>
                    </el-radio-group>
                    <jet-input-error
                      :message="form.errors.demissao_solicitada_por"
                      class="mt-2"
                    />
                  </div>
                  <div
                    v-if="form.demissao_solicitada_por === 'EMPRESA' "
                    class="col-span-12"
                  >
                    <CheckGroup
                      id-value="id"
                      label-value="nome"
                      :is-initial-open="true"
                      :items="motivos"
                      :initial-selecteds="[]"
                      v-model="form.motivos"
                      class-col-item="md:grid-cols-2 grid-cols-1"
                    ></CheckGroup>
                    <jet-input-error
                      :message="form.errors.motivos"
                      class="mt-2"
                    />
                  </div>
                </div>
                <div class="flex items-center justify-end px-4  bg-gray-50 text-right sm:px-6">
                  <jet-action-message
                    :on="form.recentlySuccessful"
                    class="mr-3"
                  > Salvo.</jet-action-message>
                </div>
                <div
                  v-if="podeSalvar"
                  class="flex flex-row-reverse space-x-4 space-x-reverse px-4  py-4 sm:py-6 bg-gray-50"
                >
                  <button-primary
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                  > Salvar
                  </button-primary>
                  <button-secondary @click.native="$inertia.get(route('processo-ajuste-nf.index'))">
                    Cancelar
                  </button-secondary>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import Breadcrumb from '@/Components/Breadcrumb';
import JetActionMessage from '@/Jetstream/ActionMessage';
import JetInputError from '@/Jetstream/InputError';
import ButtonPrimary from '@/Components/ButtonPrimary';
import ButtonSecondary from '@/Components/ButtonSecondary';
import SelectAutocomplete from '@/Components/SelectAutocomplete.vue';
import CheckGroup from '../../Components/CheckGroup.vue';

export default {
  props: {
    motivos: Array
  },
  components: {
    AppLayout,
    Breadcrumb,
    JetActionMessage,
    ButtonPrimary,
    ButtonSecondary,
    JetInputError,
    SelectAutocomplete,
    CheckGroup,
  },
  data() {
    return {
      form: this.$inertia.form({
        funcionario_id: null,
        superior_imediato: null,
        demissao_solicitada_por: null,
        motivos: []
      })
    }
  },
  methods: {
    save() {
      this.form.post(this.route('entrevista.store'));
    }
  },
  computed: {
    temFuncionario() {
      return this.form.funcionario_id;
    },
    podeSalvar() {

      if (!this.form.demissao_solicitada_por) {
        return false;
      }

      if (this.form.demissao_solicitada_por === 'FUNCIONARIO') {
        return true;
      }

      if (this.form.motivos.length) {
        return true;
      }

      return false;
    }
  }
}
</script>

<style>
</style>
